"use client";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import executeViaExecutor from './executeViaExecutor';
import executeViaClient from './executeViaClient';
import { ChainId, PUBLIC_RPCS } from '@shared/utils/config/networks';
import { ethers } from 'ethers';
import { delay } from '@/hooks/LitSessionContext/useLitAuth';
import { executeDirectTransactionsEVM } from '@shared/utils/evm/executeDirectTransactionsEVM';
import { VersionedTransaction } from '@solana/web3.js';
import bs58 from 'bs58';
export function executeOrderWrapper(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var transactions, isWithdrawal, isSponsored, isSolana, isFlashBots, txnKey, hasSponsor, decodedResponse, additionalExecutionTime, startTime, data, sponsorTxnHash, network, mineStartTime, provider, receipt, clientExecutionResponse, e_1, sponsorTx, provider, unsignedTxnSendFundsToBackOrchestrator, gasPrice, gasLimit, blockBaseFee, originalGasCost, userBalance, totalGasCost, totalCost, updatedValue, formattedUserBalance, executionResult, e_2, error_1;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var params = _b.params, _p = _b.baseUrl, baseUrl = _p === void 0 ? '/api/wrapper?target=' : _p, environment = _b.environment, sessionSigs = _b.sessionSigs, pkp = _b.pkp, cloudWallet = _b.cloudWallet, orderType = _b.orderType, dbOrderParams = _b.dbOrderParams, transferParams = _b.transferParams, signer = _b.signer, keypair = _b.keypair;
        return __generator(this, function (_q) {
            switch (_q.label) {
                case 0:
                    if (!params) {
                        return [2 /*return*/, { error: 'No params provided ' }];
                    }
                    if (!pkp) {
                        return [2 /*return*/, { error: 'No pkp provided' }];
                    }
                    if (!cloudWallet) {
                        return [2 /*return*/, { error: 'No cloudWallet provided' }];
                    }
                    console.log('executing order orderwrapper params', params);
                    transactions = params === null || params === void 0 ? void 0 : params.transactions;
                    isWithdrawal = transactions === null || transactions === void 0 ? void 0 : transactions.transfer;
                    isSponsored = params.fees.sponsorUsd;
                    isSolana = typeof ((_c = transactions === null || transactions === void 0 ? void 0 : transactions.swap) === null || _c === void 0 ? void 0 : _c[0]) == 'string' || typeof ((_d = transactions === null || transactions === void 0 ? void 0 : transactions.transfer) === null || _d === void 0 ? void 0 : _d[0]) == 'string';
                    isFlashBots = false;
                    console.log('Executing order orderwrapper isSponsored', isSponsored, 'isSolana', isSolana, 'isWithdrawal', isWithdrawal);
                    if (isSponsored && isSolana) {
                        txnKey = isWithdrawal ? 'transfer' : 'swap';
                        params.transactions[txnKey] = (_f = (_e = params === null || params === void 0 ? void 0 : params.transactions) === null || _e === void 0 ? void 0 : _e[txnKey]) === null || _f === void 0 ? void 0 : _f.map(function (txn, idx) {
                            var vTxn = VersionedTransaction.deserialize(bs58.decode(txn));
                            try {
                                vTxn.sign([keypair]);
                                return bs58.encode(vTxn.serialize());
                            }
                            catch (e) {
                                console.log('executing order signed solana txn on client e', idx, e);
                                //will fail for txns that only require sponsor signature so just return txn
                                return txn;
                            }
                        });
                    }
                    // if (isFlashBots) {
                    //   const sponsorTransactions = [params.transactions.sponsor]?.filter(x => x)
                    //   const allowanceTransactions = [params.transactions.allowance]?.filter(x => x)
                    //   const swapTransactions = [transactions?.swap || transactions?.transfer]?.filter(x => x)
                    //   if (params?.transactions?.allowance?.length) {
                    //     params.transactions.allowance = await Promise.all(
                    //       params.transactions.allowance.map(async (x) => {
                    //         return await signer.signTransaction(x);
                    //       })
                    //     );
                    //   }
                    //   if (params?.transactions?.swap?.[0]) {
                    //     params.transactions.swap[0] = await signer.signTransaction(transactions?.swap?.[0]);
                    //   }
                    //   if (params?.transactions?.transfer?.[0]) {
                    //     params.transactions.transfer[0] = await signer.signTransaction(transactions?.transfer?.[0]);
                    //   }
                    //   orderType = 'SWAP_FLASHBOTS'
                    // }
                    console.log('Executing order start', orderType, params, cloudWallet);
                    _q.label = 1;
                case 1:
                    _q.trys.push([1, 22, , 23]);
                    if (!(!isSponsored && !isFlashBots)) return [3 /*break*/, 3];
                    console.log('Executing order executing via client', orderType);
                    return [4 /*yield*/, executeViaClient({
                            params: params,
                            pkp: pkp,
                            orderType: orderType,
                            dbOrderParams: dbOrderParams,
                            signer: signer,
                            keypair: keypair,
                            isSolana: isSolana,
                            transferParams: transferParams,
                        })];
                case 2: return [2 /*return*/, _q.sent()];
                case 3:
                    if (!(isSponsored && !isSolana && !isFlashBots)) return [3 /*break*/, 20];
                    console.log('Executing order executing executor + client' + orderType);
                    hasSponsor = transactions.sponsor;
                    console.log('Executing order hasSponsor', hasSponsor);
                    decodedResponse = null;
                    additionalExecutionTime = 0;
                    if (!hasSponsor) return [3 /*break*/, 7];
                    console.log('Executing order sponsor via lit');
                    startTime = Date.now();
                    return [4 /*yield*/, executeViaExecutor({
                            baseUrl: baseUrl,
                            environment: environment,
                            params: params,
                            pkp: pkp,
                            orderType: orderType,
                            cloudWallet: cloudWallet,
                            dbOrderParams: dbOrderParams,
                            transferParams: transferParams,
                        })];
                case 4:
                    data = _q.sent();
                    decodedResponse = (_g = data === null || data === void 0 ? void 0 : data.result) === null || _g === void 0 ? void 0 : _g.decodedResponse;
                    console.log('Executing order data', data);
                    console.log('Executing order decodedResponse', decodedResponse);
                    if (decodedResponse.error || !decodedResponse || (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.status) == 'error') {
                        return [2 /*return*/, {
                                error: 'Sponsor Transaction Failed',
                            }];
                    }
                    sponsorTxnHash = ((_h = decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransaction) === null || _h === void 0 ? void 0 : _h.hash) ||
                        ((_k = (_j = decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransactions) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.hash);
                    network = hasSponsor.chainId;
                    console.log('Executing order awaiting sponsor to be mined', network, PUBLIC_RPCS[network], sponsorTxnHash);
                    mineStartTime = Date.now();
                    provider = new ethers.providers.JsonRpcProvider(PUBLIC_RPCS[network]);
                    return [4 /*yield*/, provider.waitForTransaction(sponsorTxnHash, 1)];
                case 5:
                    receipt = _q.sent();
                    if (!receipt || receipt.status == 0) {
                        console.log('Executing Order: Sponsor Txn Failed', receipt);
                        return [2 /*return*/, {
                                error: 'Sponsor Txn Failed',
                            }];
                    }
                    console.log('Executing Order: Sponsor Txn Mined', receipt, 'time', Date.now() - mineStartTime);
                    return [4 /*yield*/, delay(200)];
                case 6:
                    _q.sent();
                    //waiting for sponsor to be mined
                    additionalExecutionTime = Date.now() - startTime;
                    _q.label = 7;
                case 7:
                    additionalExecutionTime = hasSponsor ? additionalExecutionTime : 0;
                    _q.label = 8;
                case 8:
                    _q.trys.push([8, 10, , 19]);
                    return [4 /*yield*/, executeViaClient({
                            params: params,
                            pkp: pkp,
                            orderType: orderType,
                            dbOrderParams: dbOrderParams,
                            signer: signer,
                            additionalDecodedResponse: decodedResponse,
                            additionalExecutionTime: additionalExecutionTime,
                            keypair: keypair,
                            isSolana: isSolana,
                            transferParams: transferParams,
                        })];
                case 9:
                    clientExecutionResponse = _q.sent();
                    decodedResponse = (_m = (_l = clientExecutionResponse === null || clientExecutionResponse === void 0 ? void 0 : clientExecutionResponse.dbOrderHistory) === null || _l === void 0 ? void 0 : _l.result) === null || _m === void 0 ? void 0 : _m.decodedResponse;
                    console.log('Executing order evm + sponsor pipeline clientExecutionResponse', clientExecutionResponse);
                    if ((clientExecutionResponse === null || clientExecutionResponse === void 0 ? void 0 : clientExecutionResponse.error) ||
                        (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.error) ||
                        ((_o = clientExecutionResponse === null || clientExecutionResponse === void 0 ? void 0 : clientExecutionResponse.result) === null || _o === void 0 ? void 0 : _o.error) ||
                        !(clientExecutionResponse === null || clientExecutionResponse === void 0 ? void 0 : clientExecutionResponse.result)) {
                        throw new Error(clientExecutionResponse.error || (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.error));
                    }
                    return [2 /*return*/, clientExecutionResponse];
                case 10:
                    e_1 = _q.sent();
                    console.log('Executing Order error executing via client', e_1);
                    if (!hasSponsor) return [3 /*break*/, 18];
                    sponsorTx = transactions.sponsor;
                    _q.label = 11;
                case 11:
                    _q.trys.push([11, 16, , 17]);
                    provider = new ethers.providers.JsonRpcProvider(PUBLIC_RPCS[sponsorTx.chainId]);
                    unsignedTxnSendFundsToBackOrchestrator = {
                        from: sponsorTx.to,
                        to: sponsorTx.from,
                        value: sponsorTx.value,
                        gasLimit: sponsorTx.gasLimit,
                        data: sponsorTx.data,
                        gasPrice: sponsorTx.gasPrice,
                        chainId: sponsorTx.chainId,
                    };
                    gasPrice = BigInt(sponsorTx.gasPrice);
                    gasLimit = BigInt(sponsorTx.gasLimit);
                    if (!(sponsorTx.chainId === ChainId.ARBITRUM)) return [3 /*break*/, 13];
                    return [4 /*yield*/, provider.getGasPrice()];
                case 12:
                    blockBaseFee = _q.sent();
                    if (gasPrice < BigInt(blockBaseFee === null || blockBaseFee === void 0 ? void 0 : blockBaseFee.toString())) {
                        // Increase gasPrice to be slightly above block base fee
                        gasPrice = (BigInt(blockBaseFee === null || blockBaseFee === void 0 ? void 0 : blockBaseFee.toString()) * BigInt(150)) / BigInt(100); // 10% higher than base fee
                        originalGasCost = BigInt(sponsorTx.gasPrice) * gasLimit;
                        gasLimit = originalGasCost / gasPrice;
                        console.log('Adjusted gas settings for Arbitrum:', {
                            gasPrice: gasPrice.toString(),
                            gasLimit: gasLimit.toString(),
                        });
                    }
                    _q.label = 13;
                case 13: return [4 /*yield*/, provider.getBalance(sponsorTx.to)];
                case 14:
                    userBalance = _q.sent();
                    totalGasCost = gasPrice * gasLimit;
                    totalCost = BigInt(sponsorTx.value) + totalGasCost;
                    updatedValue = void 0;
                    console.log('Executing Order userBalance revert', userBalance.toString(), 'Executing Order totalCost revert', totalCost.toString());
                    if (ethers.BigNumber.from(totalCost) > userBalance) {
                        // If user balance is not enough, adjust the value to leave user with 0 balance
                        if (userBalance > ethers.BigNumber.from(totalGasCost)) {
                            updatedValue = BigInt(userBalance.toString()) - totalGasCost;
                        }
                        else {
                            // If user doesn't even have enough for gas, set value to 0
                            updatedValue = BigInt(0);
                            // You might want to handle this case differently, as the transaction will likely fail
                            console.log('Executing Order: User does not have enough balance to cover gas costs for refund transaction');
                            throw new Error('User does not have enough balance to cover gas costs for refund transaction');
                        }
                    }
                    else {
                        updatedValue = BigInt(sponsorTx.value);
                    }
                    unsignedTxnSendFundsToBackOrchestrator.value = updatedValue;
                    unsignedTxnSendFundsToBackOrchestrator.gasLimit = gasLimit;
                    unsignedTxnSendFundsToBackOrchestrator.gasPrice = gasPrice;
                    formattedUserBalance = ethers.utils.formatEther(userBalance);
                    console.log('Executing Order Send fund back to orchestrator', unsignedTxnSendFundsToBackOrchestrator, 'formattedUserBalance', formattedUserBalance);
                    return [4 /*yield*/, executeDirectTransactionsEVM({
                            transactions: [unsignedTxnSendFundsToBackOrchestrator],
                            wallet: signer,
                            network: sponsorTx.chainId,
                            blockConfirmations: 0,
                            legacyPayloads: [
                                {
                                    gasPrice: gasPrice.toString(),
                                    gasLimit: gasLimit.toString(),
                                },
                            ],
                        })];
                case 15:
                    executionResult = _q.sent();
                    console.log('Executing Order Send fund back to orchestrator result', executionResult);
                    return [3 /*break*/, 17];
                case 16:
                    e_2 = _q.sent();
                    console.log('Error sending funds back to orchestrator', e_2);
                    return [2 /*return*/, {
                            error: 'Error sending funds back to orchestrator',
                        }];
                case 17: return [2 /*return*/, {
                        error: 'Error executing order',
                    }];
                case 18: return [3 /*break*/, 19];
                case 19: return [3 /*break*/, 21];
                case 20:
                    console.log('Executing order executing via executor', orderType);
                    //@ts-ignore
                    return [2 /*return*/, executeViaExecutor({
                            baseUrl: baseUrl,
                            environment: environment,
                            params: params,
                            sessionSigs: sessionSigs,
                            pkp: pkp,
                            orderType: orderType,
                            cloudWallet: cloudWallet,
                            dbOrderParams: dbOrderParams,
                            transferParams: transferParams,
                        })];
                case 21: return [3 /*break*/, 23];
                case 22:
                    error_1 = _q.sent();
                    console.log("Executing order last wrapper Error executing ".concat(orderType), error_1);
                    return [2 /*return*/, { error: error_1.message }];
                case 23: return [2 /*return*/];
            }
        });
    });
}
